// extracted by mini-css-extract-plugin
export default {"container":"style_container__sdH-R","card":"style_card__cstVR","row":"style_row__JjfeG","btnsRow":"style_btnsRow__3GL95"};